import mapboxgl from 'mapbox-gl';
import convertLngLat from '../../mapbox/convertLngLat';

export default function getHighlightLocationMapboxStyle(
    highlightLocation?: mapboxgl.LngLatLike
): mapboxgl.Style | undefined {

    if (!highlightLocation) return undefined;

    return {
        version: 8,
        metadata: {
            uniqueTilecacheKey: 'highlightLocation'
        },
        sources: {
            source: {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: convertLngLat(highlightLocation).toArray()
                    },
                    properties: {}
                },
            }
        },
        layers: [{
            id: 'symbol',
            type: 'symbol',
            source: 'source',
            layout: {
                'icon-ignore-placement': true,
                'icon-allow-overlap': true,
                'icon-image': 'highlightLocationIcon',
                'icon-size': 0.75,
            }
        }],
    };
}
